import { LoadingManager, type WebGLRenderer } from 'three';
import { KTX2Loader } from 'three/addons/loaders/KTX2Loader.js';
import transcoderJS from 'three/addons/libs/basis/basis_transcoder.js?url';
import transcoderWASM from 'three/addons/libs/basis/basis_transcoder.wasm?url';

/** One shared worker pool per renderer, using the transcoder pinned with Three.js. */
export function createKTX2Loader(renderer: WebGLRenderer): KTX2Loader {
  const manager = new LoadingManager();
  manager.setURLModifier(url => {
    if (url === 'basis_transcoder.js') return transcoderJS;
    if (url === 'basis_transcoder.wasm') return transcoderWASM;
    if (url.startsWith('blob:')) return url;
    throw new Error('External texture URI refused');
  });
  const loader = new KTX2Loader(manager).setWorkerLimit(2).detectSupport(renderer);
  const load = loader.load.bind(loader);
  loader.load = (url, onLoad, onProgress, onError) => load(url, onLoad, onProgress, error => {
    // GLTFLoader revokes embedded-image URLs on success, but not on failure.
    if (url.startsWith('blob:')) URL.revokeObjectURL(url);
    onError?.(error);
  });
  return loader;
}
